import { z } from "zod";

export const ManualConfigurationSchema = z.object({
  type: z.literal("MANUAL"),
  input: z.unknown().optional(),
  label: z.string().optional(),
  schemaPath: z.array(z.string()),
});

export const StandardAgentTriggerMetadataSchema = z.object({
  triggerConfiguration: z.array(ManualConfigurationSchema),
  connectionConfig: z
    .object({
      connectionId: z.string(),
    })
    .optional(),
});

export const StandardAgentTriggerSchema = z.object({
  id: z.string(),
  agentId: z.string(),
  triggerId: z.string(),
  externalTriggerId: z.string().nullable(),
  userMessage: z.string().nullable(),
  organizationId: z.string(),
  triggerMetadata: StandardAgentTriggerMetadataSchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type StandardAgentTrigger = z.infer<typeof StandardAgentTriggerSchema>;
export type StandardAgentTriggerMetadata = z.infer<
  typeof StandardAgentTriggerMetadataSchema
>;
export type ManualConfiguration = z.infer<typeof ManualConfigurationSchema>;

export const StandardAgentTriggersResponseSchema = z.object({
  triggers: z.array(StandardAgentTriggerSchema),
});

export const StandardAgentTriggerResponseSchema = z.object({
  trigger: StandardAgentTriggerSchema,
});

export const CreateStandardAgentTriggerBodySchema = z.object({
  triggerId: z.string().min(1),
  triggerMetadata: StandardAgentTriggerMetadataSchema,
  userMessage: z.string().nullable().optional(),
});

export type CreateStandardAgentTriggerBody = z.infer<
  typeof CreateStandardAgentTriggerBodySchema
>;

export const UpdateStandardAgentTriggerBodySchema = z.object({
  triggerId: z.string().min(1),
  triggerMetadata: StandardAgentTriggerMetadataSchema,
  userMessage: z.string().nullable().optional(),
});

export type UpdateStandardAgentTriggerBody = z.infer<
  typeof UpdateStandardAgentTriggerBodySchema
>;
